import React from 'react';
import {
    Filter,
    TextInput,

} from 'react-admin';



const SiteFilter = (props) => {

    return(
        <Filter {...props}>
            <TextInput label="Search by site name" source="name" alwaysOn />
        </Filter>
    )
};

export default SiteFilter;
